import { PositionControls } from "./position-controls"

export function WidgetPositioning() {
  return (
    <div className="cy:flex cy:flex-col cy:gap-4">
        <h2 className="cy:text-lg! cy:font-bold cy:m-0!">Widget position</h2>
        <PositionControls />
      </div>
  )
}
